const Close = ({className}) => {
  return <span className={`icon-Close ${className}`}></span>;
};

export default Close;
